<template>
	<div class="login_bg">
		<div class="account">
			<div class="login_head">
				<img src="../../assets/images/new/login_head.png" alt="" />
			</div>
			<div class="account__container" v-if="!isUpdatePass">
				<div class="account__container__left"></div>
				<div class="account__container__right">
					<div class="login-container" v-if="loginShow">
						<div class="login-container__header">
							<span v-if="isCodeLogin" @click="passwordLogin()" :class="isCodeLogin && !isSmsLogin ? 'bold' : ''" class="js-tab-password-login"
								>密码登录</span
							>
							<span v-if="isCodeLogin" @click="ssmLogin" :class="isSmsLogin ? 'bold' : ''" class="js-tab-password-login">验证码登录</span>
							<div v-if="!isCodeLogin" class="w100s align-items">
								<div :class="!isCodeLogin ? 'bold' : ''" class="js-tab-password-login">
									扫码登录
								</div>
								<div @click="togglePwd" class="cur blue">
									密码登录
								</div>
							</div>
						</div>
						<el-form class="zent-form zent-form--horizontal" :rules="rules" ref="loginForm" :model="loginForm" v-if="isCodeLogin">
							<div class="account-input mt78">
								<el-form-item class="zent-input-wrapper account-input__input" prop="passport" :rules="$rules.required">
									<div class="zent-input">
										<el-input
											v-model="loginForm.passport"
											required
											placeholder="请输入手机号码"
											name="passport"
											tabindex="1"
											maxlength="11"
										></el-input>
									</div>
								</el-form-item>
							</div>
							<div class="account-input mt36" v-if="!isSmsLogin">
								<el-form-item class="zent-input-wrapper account-input__input" prop="passport" :rules="$rules.required">
									<div class="zent-input">
										<el-input
											v-model="loginForm.password"
											type="password"
											required
											placeholder="请输入密码"
											name="passport"
											tabindex="2"
											maxlength="6"
										></el-input>
										<el-link type="primary" @click="forgotPassword" class="account-captcha__btn js-get-identify-code">忘记密码 </el-link>
									</div>
								</el-form-item>
							</div>
							<!-- <div class="account-input mt36" v-if="!isSmsLogin">
								<el-form-item
									class="zent-input-wrapper account-input__input"
									prop="passport"
									:rules="$rules.required"
								>
									<div class="zent-input">
										<el-input
											v-model="loginForm.password"
											type="password"
											required
											placeholder="请输入密码"
											name="passport"
											tabindex="2"
											maxlength="6"
										>
                    </el-input>
									</div>
								</el-form-item>
							</div> -->

							<template v-if="isSmsLogin">
								<div class="account-input">
									<el-form-item class="zent-input-wrapper account-input__input other-input" prop="imgVerifyCode">
										<div class="zent-input">
											<el-input
												v-model.trim="loginForm.imgVerifyCode"
												placeholder="请输入图形验证码"
												name="imgVerifyCode"
												tabindex="2"
												maxlength="6"
											></el-input>
											<el-image :src="imgUrl" @click="getvCode" class="imgs account-captcha__btn js-get-identify-code"></el-image>
										</div>
									</el-form-item>
								</div>

								<div class="account-input mt36">
									<el-form-item class="zent-input-wrapper account-input__input" prop="smsVerifyCode" :rules="$rules.required">
										<div class="zent-input">
											<el-input
												v-model.trim="loginForm.smsVerifyCode"
												required
												placeholder="请输入短信验证码"
												name="smsVerifyCode"
												auto-complete="new-password"
												tabindex="2"
												maxlength="6"
											></el-input>
											<el-link
												type="primary"
												@click="addLoginCode"
												class="account-captcha__btn js-get-identify-code"
												:disabled="!loginCodeName"
												>{{ loginCodeName ? '获取短信验证码' : loginTime + 's' }}</el-link
											>
										</div>
									</el-form-item>
								</div>
							</template>
							<div class="isChecked isRegist">
								<el-checkbox v-model="checked"></el-checkbox>&nbsp;&nbsp;我已阅读并同意<span class="isBlue cur" @click="agreementClick('user')"
									>《用户协议》</span
								>以及<span class="isBlue cur" @click="agreementClick('privacy')">《隐私政策》</span>
							</div>
							<el-form-item class="login-container__auto">
								<el-button type="primary" size="medium" class="denglu" native-type="“submit”" @click.native.prevent="submitForm('loginForm')"
									>登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button
								>
							</el-form-item>
							<div class="toggleSystem cur" @click="toggleSystem">切换至商家后台</div>
						</el-form>

						<div v-else class="mt78">
							<div v-if="isLogin">
								<div class="pc_img">
									<img src="../../assets/images/new/pc.png" alt="" />
								</div>
								<div class="qrSuccess">扫码完成</div>
								<div class="qrSuccess-tip">
									请在手机上确定登录
								</div>
							</div>
							<div v-else class="is-qr-code">
								<div class="isfailure" v-if="isRefresh"></div>
								<div class="refresh-title" v-if="isRefresh">
									<div>二维码已失效</div>
									<div class="refresh" @click="clickRefresh">
										点击刷新
									</div>
								</div>
								<vue-qr :margin="10" :size="160" :text="'http://www.ysk.com?type=login&uuid=' + uuid + '&time='" class="vueQr"></vue-qr>
								<div class="qr-tip mt20" v-if="!isRefresh">
									请在一分钟有效期内使用商家端APP扫码登录
									<!-- 请打开<span>商家端APP</span>扫码登录，二维码有效期为<span>{{refreshTime}}</span>分钟 -->
								</div>
							</div>
						</div>
					</div>
					<span class="login-qr-code" @click="loginQrCode" v-if="isCodeLogin"><img src="../../assets/images/new/loginQrCode.png" alt=""/></span>
				</div>
			</div>
			<div class="account__updatePass" v-else>
				<div class="account__updatePass_box">
					<div class="account__updatePass_title">重置密码</div>
					<el-form class="zent-form zent-form--horizontal" :rules="rules" ref="updateForm" :model="updateForm">
						<div class="account-input mt78">
							<el-form-item class="account-input__input" prop="mobile" :rules="$rules.required">
								<div class="zent-input">
									<el-input
										v-model="updateForm.mobile"
										placeholder="请输入手机号码"
										name="mobile"
										tabindex="1"
										maxlength="11"
										@input="updateForm.mobile = updateForm.mobile.replace(/\D/g, '')"
									></el-input>
								</div>
							</el-form-item>
						</div>
						<div class="account-input mt36">
							<el-form-item class="zent-input-wrapper account-input__input" prop="verifyCode" :rules="$rules.required">
								<div class="zent-input">
									<el-input
										v-model.trim="updateForm.verifyCode"
										placeholder="请输入短信验证码"
										name="verifyCode"
										auto-complete="new-password"
										tabindex="2"
										maxlength="6"
									></el-input>
									<el-link type="primary" @click="clickSmsImg" class="account-captcha__btn js-get-identify-code" :disabled="!updateFlag">{{
										updateFlag ? '获取短信验证码' : updateTimes + 's'
									}}</el-link>
								</div>
							</el-form-item>
						</div>
						<div class="account-input mt36">
							<el-form-item class="account-input__input" prop="newPassword" :rules="$rules.required">
								<div class="zent-input">
									<el-input
										v-model="updateForm.newPassword"
										type="password"
										placeholder="请输入密码"
										name="newPassword"
										show-password
										autocomplete="new-password"
										maxlength="6"
									></el-input>
								</div>
							</el-form-item>
						</div>
						<div class="account-input mt36">
							<el-form-item class="account-input__input" prop="comfirmPassword" :rules="$rules.required">
								<div class="zent-input">
									<el-input
										v-model="updateForm.comfirmPassword"
										type="password"
										show-password
										placeholder="请再次确认密码"
										name="comfirmPassword"
										autocomplete="new-password"
										maxlength="6"
									></el-input>
								</div>
							</el-form-item>
						</div>
						<el-form-item class="login-container__auto">
							<el-button type="primary" size="medium" class="denglu" native-type="“submit”" @click.native.prevent="saveUpdatePass"
								>确&nbsp;&nbsp;&nbsp;&nbsp;定</el-button
							>
							<!-- saveUpdatePass -->
						</el-form-item>
					</el-form>
				</div>

				<div class="tips mt20 cur" @click="isUpdatePass = false">已有账号？<span class="goLogin">登录</span></div>
			</div>
		</div>
		<userAgree ref="userForm"></userAgree>
		<Verify @success="onSuccess" :mode="'pop'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }" ref="verify"></Verify>
	</div>
</template>

<script>
import { decrypt, encrypt } from '../../assets/javascript/untils'
import VueQr from 'vue-qr'
import userAgree from './modules/userAgreement.vue'
import minxin from '../../assets/javascript/minxin'
import Verify from './../../components/verifition/Verify'
import { menuInfoSet } from '../../assets/javascript/menu'
export default {
	data: function() {
		return {
			isCodeLogin: true,
			loginShow: true,
			loginTime: 60,
			isSmsLogin: false,
			loginCodeName: true,
			imgUrl: '',
			imgUrlKey: '',
			loginForm: {
				//登录
				passport: '',
				password: '',
				imgVerifyCode: '',
				smsVerifyCode: '',
			},
			rules: {
				passport: [
					{
						required: true,
						message: '请输入用户名',
						trigger: 'blur',
					},
				],
				password: [
					{
						required: true,
						message: '请输入密码',
						trigger: 'blur',
					},
				],
			},
			uuid: '',
			menuInfo: [],
			isLogin: false,
			isRefresh: false,
			isUpdatePass: false,
			updateForm: {
				mobile: '',
				verifyCode: '',
				newPassword: '',
				comfirmPassword: '',
				imgVerifyCode: '', // 图形验证码
			},
			updateTime: null,
			updateTimes: 60,
			updateFlag: true,
			checked: false,
			timer: null,
			refreshTime: 0,
		}
	},
	mixins: [minxin],
	created() {
		localStorage.clear()
		this.getvCode()
		var r = this.getQueryVariable('token')
		console.log(r)
		if (r) {
			this.goLogin(r)
		}
		if (navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('WebKit') > -1) {
		} else {
			alert('"您的浏览器版本过低，推荐使用谷歌浏览器打开')
		}
	},
	components: { VueQr, userAgree, Verify },
	mounted() {},
	methods: {
		async goLogin(r) {
			let resp = await this.$api.post(this.$url.tokenSignIn, { accessToken: r, platformType: 'pc' })
			if (resp) {
				this.$store.commit('setLoginUser', resp)
				if (resp.shopList.length == 1) {
					this.selectShop(resp.shopList[0])
				} else {
					this.$router.push('/center')
				}
			}
		},
		agreementClick(type) {
			this.$refs['userForm'].$emit('on', type)
		},
		passwordLogin() {
			this.isCodeLogin = true
			this.isSmsLogin = false
			this.loginForm.smsVerifyCode = ''
		},
		ssmLogin() {
			this.isSmsLogin = true
			this.loginForm.imgVerifyCode = ''
			this.loginForm.smsVerifyCode = ''
			this.loginForm.password = ''
		},
		getvCode() {
			//this.imgUrl = this.timestamp(this.$url.getImg1);
			this.$api
				.post(this.$url.getImg)
				.then((res) => {
					this.imgUrlKey = res.key
					this.imgUrl = res.imageBaseCode
				})
				.catch((error) => {})
		},
		addLoginCode() {
			if (this.loginForm.passport == '') {
				this.$message.error('请输入电话号码')
				return false
			}
			if (this.loginForm.passport.length != 11) {
				this.$message.error('请输入正确的电话号码')
				return false
			}
			if (this.loginForm.imgVerifyCode == '') {
				this.$message.error('请输入正确的验证码')
				return false
			}
			if (!this.checked) {
				return this.$message.error('请先阅读并同意用户协议以及隐私政策')
			}
			let auth_timetimer = setInterval(() => {
				if (this.loginTime <= 0) {
					this.loginTime = 60
					this.loginCodeName = true
					clearInterval(auth_timetimer)
				}
				this.loginTime--
			}, 1000)
			let arr = encrypt(
				JSON.stringify({
					mobile: this.loginForm.passport,
					bizType: 'login',
					imgCode: this.loginForm.imgVerifyCode,
					imgKey: this.imgUrlKey,
					platformType: 'pc',
				})
			)
			this.$api.post(this.$url.sendNoLogin, arr).then((resp) => {
				if (resp) {
					this.loginCodeName = false
				} else {
					this.loginCodeName = true
					this.getvCode()
					clearInterval(auth_timetimer)
				}
				this.loginTime = 60
			})
		},
		submitForm(formName) {
			if (!this.checked) {
				return this.$message.error('请先阅读并同意用户协议以及隐私政策')
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.isCodeLogin) {
						console.log(this.loginForm)
						let arr = encrypt(
							JSON.stringify({
								mobile: this.loginForm.passport,
								password: this.loginForm.password,
								verifyCode: this.loginForm.smsVerifyCode,
								imei: '',
								deviceId: '',
								registrationId: '',
								platformType: 'pc',
								millisecond: new Date().getTime(),
							})
						)
						this.$api.post(this.$url.login, arr).then((resp) => {
							if (resp) {
								this.$store.commit('setLoginUser', resp)
								if (resp.shopList.length == 1) {
									this.selectShop(resp.shopList[0])
								} else {
									this.$router.push('/center')
								}
							}
						})
					}
				}
			})
		},
		appSize() {
			this.$refs.authWrapper.width = document.body.clientWidth
			this.$refs.authWrapper.height = document.body.clientHeight
		},
		timestamp(url) {
			var getTimestamp = new Date().getTime()
			if (url.indexOf('?') > -1) {
				url = url + '&timestamp=' + getTimestamp
			} else {
				url = url + '?timestamp=' + getTimestamp
			}
			return url
		},
		loginQrCode() {
			if (!this.checked) return this.$message.error('请先阅读并同意用户协议以及隐私政策')
			this.isCodeLogin = false
			this.isRefresh = false
			this.$api.get(this.$url.getQrCode).then((res) => {
				console.log(res)
				if (res) {
					this.uuid = res.uuid
					this.refreshTime = Number(res.expireTimeSecond) / 60
					this.polling()
				}
			})
		},
		clickRefresh() {
			this.isRefresh = false
			this.loginQrCode()
		},
		polling() {
			this.$api
				.post(this.$url.signInByQrCode, {
					uuId: this.uuid,
					type: 'login',
				})
				.then((res) => {
					if (res) {
						if (res.code == '200') {
							// 成功
							this.$store.commit('setLoginUser', res.data)
							if (res.data.shopList.length == 1) {
								this.selectShop(res.data.shopList[0])
              } else {
                let arr = res.data.shopList.filter(item => item.selectFlag)
                this.selectShop(arr[0])
							}
							clearTimeout(this.timer) //清理定时任务
						} else if (res.code == '0001') {
							// 正在处理中
							this.isLogin = true
							this.timer = setTimeout(() => {
								this.polling()
							}, 3000)
						} else if (res.code == '0002') {
							// 已失效
							this.isLogin = false
							this.isRefresh = true
							clearTimeout(this.timer)
						} else if (res.code == '0003') {
							// uuid 不能为空
							this.isRefresh = true
							this.$notify.error({
								title: '错误',
								message: res.message,
								type: 'success',
							})
						} else if (res.code == '0004') {
							// 登录已经失效，请重新登录
							this.isRefresh = true
							this.$notify.error({
								title: '错误',
								message: res.message,
								type: 'success',
							})
						}
					} else {
						if (res == 'false') return
						this.timer = setTimeout(() => {
							this.polling()
						}, 3000)
					}
				})
		},
		getMenus() {
			this.$api
				.post(this.$url.common.allMenuList, {
					queryFrom: 'pc',
				})
				.then((res) => {
					if (res) {
						this.menuInfo = res
						this.setMenu()

						this.$store.commit('setShowMenus', res)
					}
				})
				.catch((error) => {})
		},
		setMenu() {
			if (this.menuInfo) {
				menuInfoSet(this.menuInfo, 'cashierAndShop')
			}
			// 跳转菜单
			this.mainMenu()
		},
		mainMenu() {
			let mainMenuList = localStorage.getItem('mainMenuList')
			let url = '/collectMoney'
			let setCurentPage = 'cashier'
			if (mainMenuList != null && mainMenuList.length > 0) {
				let code = mainMenuList[0].code
				if (code == 'collectMoney') {
					url = '/collectMoney'
					setCurentPage = 'cashier'
				} else if (code == 'shop') {
					url = '/manage'
					setCurentPage = 'shop'
				} else if (code == 'member') {
					url = '/member'
					setCurentPage = ''
				} else if (code == 'order') {
					url = '/orderInfo'
					setCurentPage = ''
				} else if (code == 'workPlateForm') {
					url = '/dataList'
					setCurentPage = 'data'
				}
			} else {
				this.$message.error('请先联系相关人员分配门店角色')
				return false
			}
			console.log('跳转菜单：', mainMenuList[0])
			this.$store.commit('setCurentPage', setCurentPage)
			this.$router.push(url)
		},
		selectShop(item) {
			this.$api
				.post(this.$url.shop.switchShop, {
					platformType: 'merchantweb',
					registrationId: '',
					shopId: item.id,
				})
				.then((res) => {
					if (res) {
						localStorage.setItem('shopIds', res.shopId)
						localStorage.setItem('mainMenuList', JSON.stringify(res.mainMenuList))
						this.getMenus()
						this.$store.commit('setShopMessage', res)
						this.getStaffPermCodeFunc()
					}
				})
		},
		async getStaffPermCodeFunc() {
			let res = await this.$api.get(this.$url.common.getStaffPermCode)
			if (res) {
				console.log(res, 'permDir')
				localStorage.setItem('permissions', JSON.stringify(res.permMap))
			}
		},
		clickSmsImg() {
			if (!this.updateForm.mobile) {
				return this.$message.error('请输入电话号码')
			}
			if (this.updateForm.mobile.length != 11) {
				this.$message.error('请输入正确的电话号码')
				return false
			}
			this.$refs.verify.show()
		},
		updateSms(captchaVerification) {
			let arr = {
				mobile: this.updateForm.mobile,
				captchaVerification: captchaVerification,
				// platformType: 'pc',
			}
			console.log({
				mobile: this.updateForm.mobile,
				captchaVerification: captchaVerification,
				// platformType: 'pc',
			})
			this.$api.post(this.$url.sendV3FindPwd, arr).then((resp) => {
				if (resp) {
					this.$message.success('发送成功')
					this.updateFlag = false
					this.updateTime = setInterval(() => {
						if (this.updateTimes <= 1) {
							this.updateFlag = true
							this.updateTimes = 60
							clearInterval(this.updateTime)
						} else {
							this.updateTimes--
						}
					}, 1000)
				}
			})
		},
		async forgotPassword() {
			if (this.updateTime) {
				clearInterval(this.updateTime)
			}
			this.updateForm = {
				mobile: '',
				verifyCode: '',
				newPassword: '',
				comfirmPassword: '',
			}
			this.updateFlag = true
			this.isUpdatePass = true
		},

		saveUpdatePass() {
			if (!this.updateForm.mobile) {
				return this.$message.error('请输入电话号码')
			} else if (this.updateForm.mobile.length != 11) {
				this.$message.error('请输入正确的电话号码')
				return false
			} else if (!this.updateForm.verifyCode) {
				this.$message.error('请输入短信验证码')
				return false
			} else if (!this.updateForm.newPassword) {
				this.$message.error('请输入新密码')
				return false
			} else if (!this.updateForm.comfirmPassword) {
				this.$message.error('请再次输入新密码')
				return false
			} else if (this.updateForm.newPassword != this.updateForm.comfirmPassword) {
				this.$message.error('两次密码不一致')
				return false
			}
			console.log(this.updateForm, 'updateForm')
			this.$api.post(this.$url.findPwd, encrypt(JSON.stringify(this.updateForm))).then((resp) => {
				if (resp) {
					this.$message.success('修改成功')
					this.updateForm = {
						mobile: '',
						verifyCode: '',
						newPassword: '',
						comfirmPassword: '',
					}
					this.updateTimes = 60
					clearInterval(this.updateTime)
					this.isUpdatePass = false
				}
			})
			// verificationCode  findPwd
		},
		togglePwd() {
			this.isCodeLogin = true
			clearTimeout(this.timer)
		},
		toggleSystem() {
			let url = 'https://merchant-health.yuansikang.com/h5/#/ssoLogin'
			if (window.location.href.indexOf('testapi') > 0) {
				url = 'https://testmerchant-health.yuansikang.com/h5/#/ssoLogin'
			} else {
				url = 'https://merchant-health.yuansikang.com/h5/#/ssoLogin'
			}
			var a = document.createElement('a')
			a.href = url
			document.body.appendChild(a)
			a.click()
			a.remove()
		},
		onSuccess(params) {
			console.log(params)
			this.updateSms(params.captchaVerification)
		},
	},
}
</script>
<style lang="less">
.login_bg {
	height: 100%;
}

.zent-input .el-input__inner {
	border: none !important;
	padding: 0;
	font-size: 16px;
}

.zent-input .el-input--small .el-input__inner {
	line-height: 48px;
	width: 100%;
	height: 48px;
}
</style>
<style lang="less" scoped>
div .el-input {
	width: 100%;
	height: 48px;
}

.el-form-item--small .el-form-item__content {
	line-height: 48px;
}

div .el-form-item--small.el-form-item {
	margin-bottom: 0;
}

.denglu {
	width: 100% !important;
	margin: 16px 0 0;
	height: 48px;
	background: #409eff;
	font-size: 18px;
}

.account {
	position: relative;
	// width: 100vw;
	width: 100%;
	height: 100%;
	min-width: 1200px;
	min-height: 680px;
	overflow: auto;
	background: url('../../assets/images/new/login_background.png') no-repeat;

	.login_head {
		height: 60px;
		padding-left: 260px;
		display: flex;
		align-items: center;
		text-align: left;
		background: #fff;

		img {
			vertical-align: top;
		}
	}

	.account__logo {
		// position: absolute;
		// top: 24px;
		// left: 40px;
		margin-top: 40px;
		font-size: 24px;
		z-index: 1;
	}

	.account__container {
		display: flex;
		-ms-flex-pack: justify;
		justify-content: space-between;
		position: absolute;
		top: 50%;
		left: 50%;
		// transform: translate(-468px, -226px);
		margin-left: -468px;
		margin-top: -226px;
		box-shadow: 0px 0px 30px 0px rgba(0, 25, 135, 0.06);

		.account__container__right {
			position: relative;
			width: 496px;
			background: #fff;
			border-radius: 0 8px 8px 0;
			overflow: hidden;

			.toggleSystem {
				color: #155bd4;
			}

			.login-container {
				height: 500px;
				padding: 56px 69px 55px;
				box-sizing: border-box;

				.login-container__header {
					display: flex;
					width: 100%;
					/* justify-content: space-between; */
					-ms-flex-align: baseline;
					align-items: baseline;
					// padding-bottom: 30px;
					font-size: 18px;
					color: #969799;

					span {
						cursor: pointer;

						&:first-child {
							margin-right: 24px;
						}
					}

					.bold {
						font-weight: 500;
						font-size: 26px;
						color: #323233;
						cursor: default;
					}
				}

				.zent-form {
					margin-bottom: 30px;
					width: auto;

					.login-container__auto {
						color: #323232;
					}
				}
			}
		}

		.account__container__left {
			position: relative;
			width: 440px;
			background-image: url('../../assets/images/new/login-left.png');
			background-size: cover;
			background-position: 50%;
		}
	}
}

.account__updatePass {
	position: absolute;
	top: 50%;
	left: 50%;
	// transform: translate(-468px, -226px);
	margin-left: -275px;
	margin-top: -315px;

	.account__updatePass_box {
		width: 438px;
		height: 526px;
		padding: 56px 57px;
		background: white;
		box-shadow: 0px 0px 30px 0px rgba(0, 25, 135, 0.06);

		.account__updatePass_title {
			font-size: 26px;
			font-weight: 500;
			color: #000;
			text-align: left;
		}
	}

	.tips {
		width: 120px !important;
		margin-left: 210px;
		font-size: 16px;
		color: #999;

		.goLogin {
			color: #3388ff;
		}
	}
}

.login-qr-code {
	display: inline-block;
	width: 82px;
	height: 82px;
	position: absolute;
	top: 0;
	right: 0;
	cursor: pointer;

	img {
		width: 100%;
		vertical-align: top;
	}
}

.account-input {
	position: relative;
	display: -ms-flexbox;
	display: flex;

	.other-input {
		margin-bottom: 0;
	}

	.account-input__input {
		position: relative;
		-ms-flex: 1;
		flex: 1;
		height: 48px;
		max-height: 48px;
		line-height: 48px;
		border: 0;
		outline: 0;
		box-sizing: border-box;

		.zent-input {
			padding: 0;
			border: 0;
			box-shadow: none;
			font-size: 16px;
			color: #323232;
			border-radius: 0;
			border-bottom: 1px solid #dcdee0;
			width: 100%;

			.account-captcha__btn {
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				cursor: pointer;
			}
		}
	}
}

.vueQr {
	border: 2px solid #e2e2e2;
}

.qr-tip {
	font-size: 18px;
	color: #7e8081;
	white-space: nowrap;

	span {
		font-size: 18px;
		color: #111;
	}
}

.mt78 {
	margin-top: 50px;
}

.mt36 {
	margin-top: 20px;
}

.pc_img {
	width: 121px;
	height: 83px;
	margin: 0 auto 30px;

	img {
		width: 100%;
		height: 100%;
		vertical-align: top;
	}
}

.qrSuccess {
	font-size: 24px;
	text-align: center;
}

.qrSuccess-tip {
	margin-top: 20px;
	font-size: 16px;
	text-align: center;
}

.is-qr-code {
	position: relative;
	text-align: center;
}

.isfailure {
	position: absolute;
	left: 50%;
	top: 2px;
	margin-left: -80px;
	width: 160px;
	height: 160px;

	background: #ffffff;
	opacity: 0.9;
}

.refresh-title {
	position: absolute;
	left: 50%;
	top: 2px;
	width: 160px;
	height: 160px;
	margin-left: -80px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 14px;

	.refresh {
		margin-top: 17px;
		width: 80px;
		color: #fff;
		height: 24px;
		line-height: 24px;
		background: #3388ff;
		border-radius: 2px;
		cursor: pointer;
	}
}

.isChecked {
	font-size: 14px;
	font-weight: 500;
	color: #666;
}
</style>
